import ProductionSummaryType from "./actionTypes"

const INIT_STATE = {
  list: {
    loading: true,
    data: []
  }
}

const ProductionSummary = (state = INIT_STATE, action) => {
  switch (action.type) {
    case ProductionSummaryType.GET_PRODUCTION_SUMMARY_LIST_SUCCESS:
      return {
        ...state,
        list: action.payload,
      }

    default:
      return state
  }
}

export default ProductionSummary
